import React, { createContext, useContext, useEffect, useState } from 'react';
import { colors } from '@alixpartners/ui-components';
import {
	VENDORS_BY_CATEGORY_FILTER_DATA,
	CHART_COLORS,
	FONTSTYLE,
} from './utils';
import { getVendorsByCategory } from 'utils/apiRequests';
import {
	TooltipHeader,
	TooltipRowPinned,
	TooltipRowTitle,
	TooltipRowValue,
	TooltipWrapper,
} from './SupplierDiversity.styles';
import { renderToString } from 'react-dom/server';
import { formatNumber } from 'utils/number';

const VendorsByCategory = createContext();

const intialChartOptions = {
	chart: {
		type: 'column',
		style: { fontFamily: 'Roboto' },
		height: '27%',
	},
	exporting: { enabled: false, allowHTML: true },
	title: { text: '', align: 'left' },
	credits: { enabled: false },
	xAxis: {
		type: 'category',
		title: { text: ``, style: { ...FONTSTYLE } },
		lineColor: colors.black,
		labels: { style: { ...FONTSTYLE } },
		gridLineWidth: 0,
	},
	yAxis: {
		min: 0,
		title: { text: ``, style: { ...FONTSTYLE } },
		gridLineWidth: 0,
		labels: { style: { ...FONTSTYLE } },
		lineColor: colors.black,
		lineWidth: 1,
	},
	legend: { enabled: false },
	tooltip: {
		useHTML: true,
		backgroundColor: colors.white,
		borderWidth: 0,
		outside: true,
		borderRadius: 2,
		formatter: function() {
			const { key, y } = this;
			return renderToString(
				<TooltipWrapper>
					<TooltipHeader>{key}</TooltipHeader>
					<TooltipRowPinned>
						<div />
						<TooltipRowTitle>Vendors</TooltipRowTitle>
						<TooltipRowValue>{formatNumber(y)}</TooltipRowValue>
					</TooltipRowPinned>
				</TooltipWrapper>
			);
		},
	},
	series: [
		{
			name: 'Vendors',
			color: CHART_COLORS[0],
			data: [],
		},
	],
};

export const VendorsByCategoryProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState([]);
	const [options, setOptions] = useState(intialChartOptions);
	const [certificationFilter, setCertificationFilter] = useState(
		VENDORS_BY_CATEGORY_FILTER_DATA
	);

	useEffect(
		() => {
			getData();
		}, // eslint-disable-next-line
		[certificationFilter]
	);

	const getData = () => {
		setIsLoading(true);
		const payload = {
			certification_Flag:
				certificationFilter.selected.value === ''
					? []
					: [certificationFilter.selected.value],
		};
		getVendorsByCategory(payload)
			.then(response => {
				if (response.succeeded) {
					setData(response.data);

					const seriesResult = response.data.map(x => {
						return [x.l1, x.unique_vendors];
					});
					setOptions(prevState => ({
						...prevState,
						series: [
							{
								...prevState.series[0],
								data: seriesResult,
							},
						],
					}));
					setIsLoading(false);
				} else {
					setIsLoading(false);
				}
			})
			.catch(() => setIsLoading(false));
	};

	const certificationFilterHandler = value =>
		setCertificationFilter(prevState => ({
			...prevState,
			selected: value,
		}));

	return (
		<VendorsByCategory.Provider
			value={{
				isLoading,
				data,
				options,
				certificationFilter,
				certificationFilterHandler,
				getData,
			}}
		>
			{children}
		</VendorsByCategory.Provider>
	);
};

export const useVendorsByCategoryContext = () => {
	return useContext(VendorsByCategory);
};
